export const HOME_PATH = "/home"
export const LOGIN = "/"
export const LOGOUT_PATH = "/logout"
export const PRODUCT_ADMIN_HOME_PATH = "/productAdminHome"